<template>
  <v-container class="custom-container">
    <v-tabs
      v-model="tab"
      background-color="primary"
      center-active
      grow
      dark
    >
      <v-tab key="one">
        <v-icon left>mdi-magnify</v-icon>
        {{ $t("Buscador") }}
      </v-tab>
      <v-tab key="two">
        <v-icon left>mdi-truck-fast</v-icon>
        {{ $t("Precios y formas de envío") }}
      </v-tab>
      <v-tab key="four">
        <v-icon left>mdi-text-box</v-icon>
        {{ $t("Resúmenes") }}
      </v-tab>
      <v-tab key="five">
        <v-icon left>mdi-email</v-icon>
        {{ $t("Contacto") }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="one">
        <v-card class="">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-filter</v-icon>
            {{ $t('Filtros de búsqueda') }}
          </v-card-title>

          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12" md="3">
                <v-combobox
                  v-model="selectedTeam1"
                  :items="teams"
                  :label="$t('Equipo 1')"
                  outlined
                  dense
                  prepend-icon="mdi-account-group"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-combobox
                  v-model="selectedTeam2"
                  :items="teams"
                  :label="$t('Equipo 2')"
                  outlined
                  dense
                  prepend-icon="mdi-account-group"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-combobox
                  v-model="selectedCompetitions"
                  :items="competitions"
                  :label="$t('Competición')"
                  multiple
                  deletable-chips
                  chips
                  small-chips
                  outlined
                  dense
                  prepend-icon="mdi-trophy"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-combobox
                  v-model="selectedSeasons"
                  :items="seasons"
                  :label="$t('Temporada')"
                  multiple
                  deletable-chips
                  chips
                  small-chips
                  outlined
                  dense
                  prepend-icon="mdi-calendar"
                />
              </v-col>
            </v-row>
            
            <v-row class="mt-0">
              <v-col>
                <v-btn 
                  color="primary" 
                  @click="search_videos"
                  class="mr-2"
                  :loading="loadingTable"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  {{ $t("Buscar") }}
                </v-btn>
                <v-btn color="secondary" @click="clear">
                  <v-icon left>mdi-broom</v-icon>
                  {{ $t("Borrar") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-format-list-bulleted</v-icon>
            {{ $t('Resultados') }}
          </v-card-title>

          <v-card-text class="pa-4">

            <v-row class="mt-0">
              <v-col>
                <v-text-field
                  v-model="search"
                  :label="$t('Filtrar resultados')"
                  outlined
                  dense
                  prepend-icon="mdi-filter"
                  @change="search_videos"
                />
              </v-col>
            </v-row>

            <v-data-table
              v-model="selected"
              :loading="loadingTable"
              loading-text="Cargando partidos..."
              :headers="headers"
              :items="data"
              :search="search"
              item-key="_id"
              show-select
              class="elevation-2 rounded-lg"
              :footer-props="{
                'items-per-page-options': [10, 20, 50, 100],
                'items-per-page-text': 'Partidos por página:'
              }"
              :items-per-page="20"
            >
              <template v-slot:item.equip1="{ item }">
                <span class="font-weight-bold">{{ item.equip1 }}</span>
              </template>
              <template v-slot:item.equip2="{ item }">
                <span class="font-weight-bold">{{ item.equip2 }}</span>
              </template>
              <template v-slot:item.resultat="{ item }">
                <v-chip small color="primary" dark>{{ item.resultat }}</v-chip>
              </template>
            </v-data-table>

            <v-alert
              v-if="data.length >= maxResults"
              border="left"
              colored-border
              type="info"
              class="mt-4"
            >
              Se muestran los primeros {{ maxResults }} resultados
            </v-alert>

            <v-row class="mt-4">
              <v-col>
                <v-btn 
                  large 
                  color="primary" 
                  @click="buy"
                  :disabled="selected.length === 0"
                >
                  <v-icon left>mdi-cart</v-icon>
                  {{ $t("Realizar Pedido") }} ({{ selected.length }})
                </v-btn>
              </v-col>
              <v-col class="text-right">
                <vue-excel-xlsx
                  :disabled="!downloadEnabled"
                  :data="dataExcel"
                  :columns="columns"
                  :filename="'data'"
                  :sheetname="'data'"
                  :title="$t('Descargar')"
                  class="v-btn v-btn--has-bg theme--light v-size--default mr-2"
                >
                  <v-icon left :color="downloadEnabled ? 'primary' : ''">
                    mdi-file-excel
                  </v-icon>
                  {{ $t("Excel") }}
                </vue-excel-xlsx>
                <v-btn 
                  :disabled="!downloadEnabled"
                  @click="downloadPdf"
                >
                  <v-icon left>mdi-file-cad</v-icon>
                  {{ $t("PDF") }}
                </v-btn>
              </v-col>
            </v-row>  
          </v-card-text>
        </v-card>

        <v-dialog v-model="showForm" max-width="600">
          <v-card class="rounded-lg">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-cart</v-icon>
              {{ $t("Finalizar Pedido") }}
            </v-card-title>

            <v-card-text class="pa-4">
              <v-form v-model="valid" class="mt-3">
                <v-text-field
                  v-model="name"
                  :label="$t('Nombre completo')"
                  outlined
                  dense
                  prepend-icon="mdi-account"
                />
                <v-text-field
                  v-model="email"
                  :label="$t('E-mail')"
                  :rules="rules.email"
                  outlined
                  dense
                  prepend-icon="mdi-email"
                />
                <v-textarea
                  v-model="text"
                  rows="2"
                  :label="$t('Mensaje adicional')"
                  outlined
                  dense
                  prepend-icon="mdi-message"
                />

                <v-alert type="info" class="mb-4">
                  {{ $t("Partidos seleccionados") }}: 
                  <strong>{{ selected.length }}</strong>
                </v-alert>

                <div v-if="flase">
                <v-subheader class="pl-0">{{ $t("Forma de envío") }}</v-subheader>
                <v-radio-group v-model="envio" class="mt-0">
                  <v-radio 
                    label="Descarga por link" 
                    value="Link"
                    color="primary"
                  >
                    <template v-slot:label>
                      <div>
                        <strong>Descarga por link</strong>
                        <div class="caption">(SendGB, WeTransfer)</div>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio 
                    label="DVD" 
                    value="DVD"
                    color="primary"
                  >
                    <template v-slot:label>
                      <div>
                        <strong>DVD</strong>
                        <div class="caption">(Envío físico)</div>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
                </div>

                <v-subheader class="pl-0">{{ $t("Método de pago") }}</v-subheader>
                <v-radio-group v-model="pago" class="mt-0">

                  <v-radio 
                    label="Stripe" 
                    value="stripe"
                    color="primary"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <v-icon class="mr-2">mdi-credit-card</v-icon>
                        <span>Stripe</span>
                      </div>
                    </template>
                  </v-radio>

                  <v-radio 
                    label="Paypal" 
                    value="paypal"
                    color="primary"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <v-img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" max-width="60" class="mr-2"></v-img>
                        <span>PayPal</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio 
                    label="Bizum" 
                    value="bizum"
                    color="primary"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <v-img src="https://upload.wikimedia.org/wikipedia/commons/6/67/Bizum_logo.svg" max-width="60" class="mr-2"></v-img>
                        <span>Bizum</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio 
                    label="Transferencia bancaria" 
                    value="transferencia"
                    color="primary"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <v-icon large class="mr-2">mdi-bank-transfer</v-icon>
                        <span>Transferencia bancaria</span>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>

                <v-alert v-if="pago" border="left" class="mt-3">
                  <template v-if="pago == 'paypal'">
                    {{ $t("Cuenta de Paypal") }}: 
                    <strong>bdfutbol@gmail.com</strong>
                  </template>
                  <template v-else-if="pago == 'bizum'">
                    {{ $t("Solicitar cuenta de Bizum por email") }}
                  </template>
                  <template v-else-if="pago == 'stripe'">
                    {{ $t("Serás redirigido a Stripe para completar el pago con tarjeta") }}
                  </template>
                  <template v-else>
                    {{ $t("Solicitar datos bancarios por email") }}
                  </template>
                </v-alert>

                <div class="d-flex justify-end mt-4">
                  <v-btn text @click="cancel" class="mr-2">
                    {{ $t("Cancelar") }}
                  </v-btn>
                  <v-btn 
                    color="primary" 
                    :loading="loading" 
                    :disabled="!valid" 
                    @click="submit"
                  >
                    <v-icon left>mdi-send</v-icon>
                    {{ $t("Confirmar pedido") }}
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-tab-item>

      <v-tab-item key="two">
        <v-card class="elevation-5 rounded-lg">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-currency-eur</v-icon>
            {{ $t("Precios y formas de envío") }}
          </v-card-title>
          
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    {{ $t("Descarga digital") }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $t("5€ por partido") }}
                    (SendGB, WeTransfer, FTP)
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              
              <v-list-item class="mt-4">
                <v-list-item-icon>
                  <v-icon color="primary">mdi-gift</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold primary--text">
                    {{ $t("Ofertas especiales") }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $t("100 partidos por") }} 450 €
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            
            <v-alert border="left" color="white" class="mt-4">
              <h3 class="headline mb-2">{{ $t("Métodos de pago aceptados") }}</h3>
              <div class="d-flex flex-wrap">
                <v-chip class="ma-1" color="green" text-color="white">
                  <v-icon left>mdi-currency-eur</v-icon>
                  PayPal
                </v-chip>
                <v-chip class="ma-1" color="purple" text-color="white">
                  <v-icon left>mdi-cellphone</v-icon>
                  Bizum
                </v-chip>
                <v-chip class="ma-1" color="red" text-color="white">
                  <v-icon left>mdi-credit-card</v-icon>
                  Stripe
                </v-chip>
                <v-chip class="ma-1" color="blue" text-color="white">
                  <v-icon left>mdi-bank</v-icon>
                  {{ $t("Transferencia") }}
                </v-chip>
              </div>
            </v-alert>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item key="four">
        <Summaries />
      </v-tab-item>

      <v-tab-item key="five">
        <v-card class="elevation-5 rounded-lg">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-email</v-icon>
            {{ $t("Contacta con nosotros") }}
          </v-card-title>
          
          <v-card-text class="pa-5">
            <v-form v-model="valid2">
              <v-text-field
                v-model="name2"
                :label="$t('Nombre')"
                outlined
                dense
                prepend-icon="mdi-account"
              />
              <v-text-field
                v-model="email2"
                :label="$t('E-mail')"
                :rules="rules.email"
                outlined
                dense
                prepend-icon="mdi-email"
              />
              <v-textarea
                v-model="text2"
                rows="3"
                :label="$t('Mensaje')"
                outlined
                dense
                prepend-icon="mdi-message"
              />

              <div class="d-flex justify-end mt-4">
                <v-btn text @click="cancel2" class="mr-2">
                  {{ $t("Cancelar") }}
                </v-btn>
                <v-btn 
                  color="primary" 
                  :loading="loading2" 
                  :disabled="!valid2" 
                  @click="submit2"
                >
                  <v-icon left>mdi-send</v-icon>
                  {{ $t("Enviar mensaje") }}
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import Summaries from "./Summaries";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
    name: 'HelloWorld',
    components: {Summaries},
    data: () => ({
        tab: null,
        showForm: false,
        valid: false,
        name: "",
        email: "",
        text: "",
        loading: false,
        valid2: false,
        loadingTable: false,
        name2: "",
        email2: "",
        text2: "",
        loading2: false,
        maxResults: 0,
        pago: 'paypal',
        envio: 'Link',
        search: '',
        selected: [],
        headers: [
            { text: 'Equipo 1', value: 'equip1', },
            { text: 'Equipo 2', value: 'equip2' },
            { text: 'Resultado', value: 'resultat' },
            { text: 'Temporada', value: 'temporada' },
            { text: 'Competición', value: 'competicio' },
            { text: 'Fase', value: 'fase' },
            { text: 'Fecha', value: 'data' },
            { text: 'Canal', value: 'canal' },
            { text: 'Audio', value: 'audio' },
            { text: 'Info1', value: 'info1' },
            { text: 'Info2', value: 'info2' },
            { text: 'Info3', value: 'info3' }
        ],
        columns: [
            { label: 'Equipo 1', field: 'equip1', },
            { label: 'Equipo 2', field: 'equip2' },
            { label: 'Resultado', field: 'resultat' },
            { label: 'Temporada', field: 'temporada' },
            { label: 'Competición', field: 'competicio' },
            { label: 'Fase', field: 'fase' },
            { label: 'Fecha', field: 'data' },
            { label: 'Canal', field: 'canal' },
            { label: 'Audio', field: 'audio' },
            { label: 'Info1', field: 'info1' },
            { label: 'Info2', field: 'info2' },
            { label: 'Info3', field: 'info3' }
        ],
        cols: ['Equipo 1', 'Equipo 2', 'Resultado', 'Temporada', 'Competición', 'Fase', 'Fecha', 'Canal', 'Audio', 'Info1', 'Info2', 'Info3' ],
        colsPdf: ['Equipos', 'Tmp.', 'Competición', 'Fecha', 'Info' ],
        data: [],
        dataExcel: [],
        dataPdf: [],
        teams: [],
        selectedTeam1: [],
        selectedTeam2: [],
        seasons: [],
        selectedSeasons: [],
        competitions: [],
        selectedCompetitions: [],
        languages: [],
        selectedLanguages: [],
        channels: [],
        selectedChannels: [],
        pagination: {
            rowsPerPage: 20
        },
        rules: {
            email: [
                v => !!v || 'El campo es obligatorio',
                v => /.+@.+\..+/.test(v) || 'El correo debe ser válido'
            ],
        }
    }),
    computed: {
        downloadEnabled () {
            return this.data.length > 0;
        }
    },
    created () {
        this.maxResults = Constants.MAX_RESULTS;
        this.fetch();
    },
    methods: {
        fetch () {
            ApiRepository.teams().then((res) => { this.teams = []; for (const item of res.data) if (item.team) this.teams.push(item.team); this.teams.sort(); });
            ApiRepository.seasons().then((res) => { this.seasons = []; for (const item of res.data) if (item.season) this.seasons.push(item.season); this.seasons.sort(); });
            ApiRepository.competitions().then((res) => { this.competitions = []; for (const item of res.data) if (item.competition) this.competitions.push(item.competition); this.competitions.sort(); });
            ApiRepository.languages().then((res) => { this.languages = []; for (const item of res.data) if (item.language) this.languages.push(item.language); this.languages.sort(); });
            ApiRepository.channels().then((res) => { this.channels = []; for (const item of res.data) if (item.channel) this.channels.push(item.channel); this.channels.sort(); });
        },
        search_videos () {
            this.loadingTable = true;
            this.data = [];
            this.dataExcel = [];
            this.dataPdf = [];
            ApiRepository.search(this.selectedTeam1, this.selectedTeam2, this.selectedSeasons, this.selectedCompetitions, this.selectedLanguages, this.selectedChannels).then((res) => {
                this.data = res.data;
                for (const item of this.data) {
                    const itemExcel = {};
                    itemExcel.equip1 = item.equip1;
                    itemExcel.equip2 = item.equip2;
                    itemExcel.resultat = item.resultat;
                    itemExcel.temporada = item.temporada;
                    itemExcel.competicio = item.competicio;
                    itemExcel.canal = item.canal;
                    itemExcel.audio = item.audio;
                    itemExcel.fase = item.fase;
                    itemExcel.data = item.data;
                    itemExcel.info1 = item.info1;
                    itemExcel.info2 = item.info2;
                    itemExcel.info3 = item.info3;
                    this.dataExcel.push(itemExcel);

                    this.dataPdf.push([item.equip1 + " " + item.resultat + " " + item.equip2, item.temporada, item.competicio + " " + item.fase, item.data, item.canal + " " + item.audio + " " + item.info1 + " " + item.info2 + " " + item.info3]);
                }
                this.loadingTable = false;
            });
        },
        clear () {
            this.data = [];
            this.dataPdf = [];
            this.dataExcel = [];
            this.selectedTeam1 = [];
            this.selectedTeam2 = [];
            this.selectedSeasons = [];
            this.selectedCompetitions = [];
            this.selectedLanguages = [];
            this.selectedChannels = [];
            this.search = "";
            this.selected = [];
        },
        buy () {
            this.showForm = true;
        },
        cancel () {
            this.showForm = false;
        },
        cancel2 () {
            this.tab = "one";
        },
        downloadPdf () {
            if (this.downloadEnabled) {
                const doc = new jsPDF();

                doc.autoTable({
                    head: [this.colsPdf],
                    body: this.dataPdf,
                    headStyles: {fillColor: '#020F2A'},
                    bodyStyles: {overflow: 'linebreak', fontSize: 8}
                });

                doc.save('partidos_bdfutbol.pdf');
            }
        },
        downloadExcel() {
            // Existing Excel export functionality
        },
        submit () {
            if (this.pago === 'stripe') {
              this.loading = true

              // 1. Enviar email amb la comanda
              ApiRepository.send({
                name: this.name,
                email: this.email,
                selected: this.selected,
                text: this.text || 'Compra iniciada via Stripe',
                pago: 'stripe',
                envio: this.envio,
                from: 'bdfutbol'
              }).then(() => {
                // 2. Crear sessió de pagament
                return ApiRepository.checkoutSession({
                  email: this.email,
                  selected: this.selected
                })
              }).then(res => {
                const url = res.data.url
                if (url) {
                  window.location.href = url
                } else {
                  this.$root.$emit('show-snackbar', {
                    color: 'error',
                    message: this.$t('Error al obtener la URL de Stripe')
                  })
                }
              }).catch(err => {
                console.error(err)
                this.$root.$emit('show-snackbar', {
                  color: 'error',
                  message: this.$t('Error con Stripe') + ': ' + (err.message || '')
                })
              }).finally(() => {
                this.loading = false
              })

              return
            }

            this.loading = true;
            ApiRepository.send({name: this.name, email: this.email, selected: this.selected, text: this.text, pago: this.pago, envio: this.envio, from: "bdfutbol"}).then(
                (res) => {
                    this.loading = false;
                    if (res) {
                        this.$root.$emit('show-snackbar', {message: this.$t('Pedido enviado correctamente!')});
                        this.showForm = false;
                        this.selected = [];
                    } else {
                        this.$root.$emit('show-snackbar', {color: "error", message: this.$t('Ha ocurrido un error')});
                    }
                }).catch(err => {
                console.log(err);
                this.loading = false;
                this.$root.$emit('show-snackbar', {color: "error", message: this.$t('Ha ocurrido un error')});
            });
        },
        submit2 () {
            this.loading2 = true;
            ApiRepository.send2({name: this.name2, email: this.email2, text: this.text2, from: "bdfutbol"}).then(
                (res) => {
                    this.loading2 = false;
                    if (res) {
                        this.$root.$emit('show-snackbar', {message: this.$t('Enviado correctamente!')});
                        this.name2 = "";
                        this.email2 = "";
                        this.text2 = "";
                    } else {
                        this.$root.$emit('show-snackbar', {color: "error", message: this.$t('Ha ocurrido un error')});
                    }
                }).catch(err => {
                console.log(err);
                this.loading2 = false;
                this.$root.$emit('show-snackbar', {color: "error", message: this.$t('Ha ocurrido un error')});
            });
        }
    },
};
</script>

<style>
.vue-scope .custom-container {
  max-width: 1400px;
}

.vue-scope .v-tab {
  font-weight: 600;
}

.vue-scope .v-card {
  transition: all 0.3s ease;
}

.vue-scope .v-data-table {
  border-radius: 8px;
  overflow: hidden;
}

.vue-scope .v-data-table-header {
  background-color: #020F2A;
}

.vue-scope .v-data-table-header th {
  color: white !important;
  font-weight: bold;
}

.vue-scope .v-data-table__row:hover {
  background-color: #f5f3ff !important;
}

.vue-scope .v-alert {
  border-radius: 8px;
}

.vue-scope .v-btn {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 600;
}

.vue-scope .v-chip {
  font-weight: 600;
}
</style>